<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showOwner") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-center">
        <v-chip :color="data.active ? 'green' : 'red'" text-color="white">
          {{ data.active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Owner Main Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <div v-if="data.avatar" class="col-12">
            <!-- Display image -->
            <div class="preview-container text-center my-3">
              <img :src="data.avatar" alt="Owner Avatar" />
            </div>
          </div>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.owner_name')"
            v-model.trim="data.name"
            disabled
            class="disabled_input"
          />
          <!-- End:: Name Input -->

          <!-- Start:: Phone Input -->
          <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.full_mobile"
            readonly
            class="disabled_input"
          />
          <!-- End:: Phone Input -->

          <!-- Start:: City Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            readonly
            class="disabled_input"
          />
          <!-- End:: City Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            readonly
            class="disabled_input"
          />
          <!-- End:: Email Input -->

          <!-- Start:: Location on Map -->
          <div v-if="data.latitude && data.longitude" class="map_wrapper">
            <GmapMap
              :center="{
                lat: parseFloat(data.latitude),
                lng: parseFloat(data.longitude),
              }"
              :zoom="13"
              map-type-id="terrain"
              style="width: 100%; height: 500px"
            >
              <GmapMarker
                :position="{lat: parseFloat(data.latitude), lng: parseFloat(data.longitude)}"
                :clickable="false"
                :draggable="false"
                @click="center = m.position"
              />
            </GmapMap>
          </div>
          <!-- End:: Location on Map -->
        </div>
      </form>
      <!-- ==== End:: Owner Main Data ==== -->
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowOwner",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Data
      data: {
        id: null,
        name: null,
        email: null,
        mobile: null,
        full_mobile: null,
        country_code: null,
        city: null,
        city_id: null,
        location: null,
        latitude: null,
        longitude: null,
        is_active: null,
        avatar: null,
        wallet_balance: null,
        active: false,
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `owners/${this.$route.params.id}`,
        });
        console.log("Owner DATA =>", res.data.data);

        // Map API response to component data
        const ownerData = res.data.data.owner;
        this.data.id = ownerData.id;
        this.data.name = ownerData.name;
        this.data.email = ownerData.email;
        this.data.mobile = ownerData.mobile;
        this.data.full_mobile = ownerData.full_mobile;
        this.data.country_code = ownerData.country_code;
        this.data.city = ownerData.city;
        this.data.city_id = ownerData.city_id;
        this.data.location = ownerData.location;
        this.data.latitude = ownerData.latitude;
        this.data.longitude = ownerData.longitude;
        this.data.is_active = ownerData.is_active;
        this.data.avatar = ownerData.avatar;
        this.data.wallet_balance = ownerData.wallet_balance;
        this.data.active = ownerData.is_active;
        
        // Initialize map if coordinates are available
        if (this.data.latitude && this.data.longitude) {
          this.$nextTick(() => {
            this.initializeMap();
          });
        }
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    // Start:: Initialize Google Map
    initializeMap() {
      const mapOptions = {
        center: {
          lat: parseFloat(this.data.latitude),
          lng: parseFloat(this.data.longitude),
        },
        zoom: 15,
      };

      const map = new google.maps.Map(
        document.getElementById("map"),
        mapOptions
      );

      // Add marker
      new google.maps.Marker({
        position: {
          lat: parseFloat(this.data.latitude),
          lng: parseFloat(this.data.longitude),
        },
        map: map,
        title: this.data.name,
      });
    },
    // End:: Get Data To Show
  },

  created() {
    // Start:: Fire Methods
    this.getDataToShow();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img {
  max-width: 150px;
  max-height: 150px;
  border: 2px solid #ddd;
  border-radius: 50%;
  object-fit: cover;
}

.badges_wrapper {
  margin-bottom: 20px;
}

#map {
  border: 1px solid #ddd;
  border-radius: 8px;
}

.form-label {
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  display: block;
}
</style>
